import React from 'react';

// Selo "Powered by WMF Systems" com link externo para wmfsystems.com.br.
// Usado no Footer público, no DashboardLayout dos painéis e no AuthLayout.
//
// Props:
//   variant: 'light' (texto claro p/ fundos escuros) | 'dark' (texto escuro p/ fundos claros).
//   className: classes extras pro container.
const PoweredBy = ({ variant = 'dark', className = '' }) => {
  const isLight = variant === 'light';
  const baseColor = isLight ? 'text-white/60 hover:text-white' : 'text-app-text-secondary hover:text-app-text';
  const accent = isLight ? 'text-white/90' : 'text-app-text';

  return (
    <a
      href="https://wmfsystems.com.br"
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center gap-1 text-xs transition-colors ${baseColor} ${className}`}
      aria-label="Powered by WMF Systems"
    >
      <span>Powered by</span>
      <span className={`font-semibold ${accent}`}>WMF Systems</span>
    </a>
  );
};

export default PoweredBy;
